import _objectWithoutProperties from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/defineProperty";
var _excluded = ["styles", "children"];

var _fadeStyles;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import classNames from 'classnames';
import { Transition } from 'react-transition-group';
import { applyStylingHoc } from '../../lib/styling.js';
import { ENTERED, ENTERING } from 'react-transition-group/Transition.js';
import baseStyles from './Fade.scss';
var defaultProps = {
  in: false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false
};
var fadeStyles = (_fadeStyles = {}, _defineProperty(_fadeStyles, ENTERING, 'in'), _defineProperty(_fadeStyles, ENTERED, 'in'), _fadeStyles);
export var Fade = function Fade(_ref) {
  var styles = _ref.styles,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  return React.createElement(Transition, _objectSpread({}, props), function (status, innerProps) {
    return React.cloneElement(children, _objectSpread(_objectSpread({}, innerProps), {}, {
      className: classNames(styles.root, children.props.className, // @ts-ignore
      fadeStyles[status])
    }));
  });
};
Fade.defaultProps = defaultProps;
export default applyStylingHoc(baseStyles)(Fade);